export const colorNameToHex = {
  "Red": "#E15A5A",              // Strong red (clear and vibrant)
  "Yellow": "#FFD700",           // Bright gold yellow (distinct from others)
  "Orange": "#FF8C00",           // Deep orange (more vivid)
  "DeepSkyBlue": "#1E90FF",      // Deep sky blue (distinct from others)
  "DarkBlue": "#00008B",         // A solid, deep dark blue
  "DarkGrayBlue": "#666699",        // Added for example
  "Green": "#32CD32",            // Lime green (bright and vibrant)
  "Violet": "#9F7AEA",           // Soft but distinct violet (purple variant)
  "Pink": "#FF69B4",             // Bright pink (distinct and easy to spot)
  "Magenta": "#D500F9",          // Vivid magenta (darker and more saturated)
  "Purple": "#8A2BE2",           // Strong, royal purple (rich tone)
  "Coral": "#FF5722",            // Warm coral (orange-red tone)
};